import React from 'react';

import { SideMenu } from '@vlabs/uikit';

import { AnalyticsTypeDropdown } from '@vlabs/monokit/entities/sources';
import { SectionErrorIcon } from '@vlabs/monokit/shared/ui/side-nav-layout';

import { useSourceGroupSettingsNavTranslation } from './i18n';
import st from './SourceGroupSettingsNav.module.sass';
import type { SourceGroupAnalyticsItem, SourceGroupSection } from './types';

interface SourceGroupSettingsNavProps {
  activeSection: SourceGroupSection;
  onChange: (section: SourceGroupSection) => void;
  sectionErrors?: Partial<Record<SourceGroupSection, boolean>>;
  analyticsItems?: SourceGroupAnalyticsItem[];
  onAddAnalytics?: (type: string) => void;
}

const SECTIONS: { key: SourceGroupSection; labelKey: string }[] = [
  { key: 'general', labelKey: 'sections.general' },
  { key: 'streams', labelKey: 'sections.streams' },
  { key: 'stream-settings', labelKey: 'sections.stream_settings' },
];

function SourceGroupSettingsNav({
  activeSection,
  onChange,
  sectionErrors = {},
  analyticsItems = [],
  onAddAnalytics = undefined,
}: SourceGroupSettingsNavProps): React.JSX.Element {
  const { t } = useSourceGroupSettingsNavTranslation();

  return (
    <React.Fragment>
      {SECTIONS.map((section) => (
        <React.Fragment key={section.key}>
          <SideMenu.MenuItem
            data-testid={`source-group-nav-${section.key}`}
            isActive={activeSection === section.key}
            onClick={() => onChange(section.key)}
            rightIcon={<SectionErrorIcon hasError={!!sectionErrors[section.key]} />}
            value={t(section.labelKey)}
          />
          <SideMenu.MenuItemDivider />
        </React.Fragment>
      ))}

      <SideMenu.MenuItem
        data-testid="source-group-nav-va-group"
        isOpened
        value={t('va_group')}
      >
        {analyticsItems.map((item) => (
          <SideMenu.MenuItem
            data-testid={`source-group-nav-${item.key}`}
            isActive={activeSection === item.key}
            key={item.key}
            onClick={() => onChange(item.key)}
            rightIcon={<SectionErrorIcon hasError={!!sectionErrors[item.key]} />}
            value={item.title}
          />
        ))}

        {!!onAddAnalytics && (
          <div className={st.AddAnalytics}>
            <AnalyticsTypeDropdown
              addLabel={t('add_analytics')}
              data-testid="source-group-nav-add-analytics"
              onAdd={onAddAnalytics}
            />
          </div>
        )}
      </SideMenu.MenuItem>
    </React.Fragment>
  );
}

export { SourceGroupSettingsNav };
